import styled from "styled-components";
import { Link } from "react-router-dom";

const StyledAppButton = styled.button.attrs({ className: "btn btn-app" })`
  margin: 0;
`;

const StyledButton = styled.button.attrs((props) => ({
  className: `btn ${props.color ? "btn-" + props.color : "btn-secondary"} ${
    props.size ? "btn-" + props.size : ""
  }`,
}))`
  display: flex;
  align-items: center;
  font-weight: normal;
  font-size: 1rem;
  cursor: pointer;
`;

const StyledOutlineButton = styled.button.attrs((props) => ({
  className: `btn ${
    props.color ? "btn-outline" + props.color : "btn-outline-secondary"
  } ${props.size ? "btn-" + props.size : ""}`,
}))`
  display: flex;
  align-items: center;
  font-weight: normal;
  font-size: 1rem;
  cursor: pointer;
`;

export default function Button({ children, isLoading, variant, as, ...props }) {
  if (variant === "app")
    return <StyledAppButton {...props}>{children}</StyledAppButton>;
  if (as === "link") {
    return (
      <Link {...props} className={`btn btn-secondary ${props.className}`}>
        {children}
      </Link>
    );
  }
  if (variant === "tool")
    return (
      <button {...props} className="btn btn-tool">
        {children}
      </button>
    );
  if (variant === "outline")
    return (
      <StyledOutlineButton {...props}>
        {isLoading ? (
          <>
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span className="sr-only">Loading...</span>
          </>
        ) : (
          children
        )}
      </StyledOutlineButton>
    );
  return (
    <StyledButton {...props}>
      {isLoading ? (
        <>
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span className="sr-only">Loading...</span>
        </>
      ) : (
        children
      )}
    </StyledButton>
  );
}

export function ButtonTool({ children, ...props }) {
  return (
    <button {...props} className="btn btn-tool">
      {children}
    </button>
  );
}

export function IconButton({ icon, ...props }) {
  return <button {...props}>{icon}</button>;
}
